import React from 'react';
import { useFetcher } from 'react-router-dom';
import type { ActionResult } from '@oysterjs/core/graphql/actions';
import { Button } from '@oysterjs/ui/button';

import { actionFailureMessage } from './action-failure';
import { EmailTemplateArchiveDialog } from './email-template-archive-dialog';
import { emailTemplatePath } from './email-template-paths';

export const EmailTemplateArchiveButton = ({
  template,
  onArchived
}: {
  template: { id: string; name: string };
  onArchived: () => void;
}) => {
  const fetcher = useFetcher<ActionResult<unknown>>();
  const [isConfirming, setIsConfirming] = React.useState(false);
  const isArchiving = fetcher.state !== 'idle';
  const failure = isArchiving ? null : actionFailureMessage(fetcher.data);
  const isArchived = !isArchiving && !!fetcher.data && !failure;

  React.useEffect(() => {
    if (isArchived) onArchived();
  }, [isArchived]);

  return (
    <>
      <Button plain className="mr-auto" onClick={() => setIsConfirming(true)}>
        Archive
      </Button>
      <EmailTemplateArchiveDialog
        templateName={template.name}
        open={isConfirming}
        failure={failure}
        isArchiving={isArchiving}
        onCancel={() => setIsConfirming(false)}
        onConfirm={() =>
          fetcher.submit(
            {},
            {
              method: 'post',
              encType: 'application/json',
              action: `${emailTemplatePath(template.id)}/archive`
            }
          )
        }
      />
    </>
  );
};
